// All in-app notification APIs
import {
  ApiEnvelope,
  MarkAllReadData,
  NotificationCategory,
  NotificationListData,
  NotificationListParams,
  StreamTicketData,
  UnreadCountData,
} from "../types/notification.type";
import { apiClient } from "./client";

export const notificationsApi = {
  list: (params?: NotificationListParams) =>
    apiClient.get<ApiEnvelope<NotificationListData>>(`/notifications`, {
      params,
    }),

  unreadCount: () =>
    apiClient.get<ApiEnvelope<UnreadCountData>>(`/notifications/unread-count`),

  markAsRead: (id: string) =>
    apiClient.patch<ApiEnvelope<null>>(`/notifications/${id}/read`),

  markAllAsRead: (category?: NotificationCategory) =>
    apiClient.patch<ApiEnvelope<MarkAllReadData>>(
      `/notifications/read-all`,
      category ? { category } : {}
    ),

  // Mints the short-lived (30s), single-use ticket used to open the SSE stream.
  // This call goes through the normal proxy; the stream connection itself does not.
  getStreamTicket: () =>
    apiClient.post<ApiEnvelope<StreamTicketData>>(
      `/notifications/stream-ticket`
    ),
};
